<template>
  <div>
    <SnackbarComponent
      v-model="snackbar.show"
      :message="snackbar.message"
      :color="snackbar.color"
    />
  <v-dialog
    v-model="dialog"
    max-width="500px"
    persistent
  >
    <v-card>
      <v-card-title class="text-h5 pa-4">
        Delete Administrator
      </v-card-title>

      <v-divider></v-divider>

        <v-card-text class="pa-6">
        <p class="text-body-1">
          Are you sure you want to delete this administrator? This action cannot be undone.
        </p>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="pa-4">
        <v-spacer></v-spacer>
        <v-btn
          color="grey"
          variant="text"
          @click="handleClose"
        >
          Cancel
        </v-btn>
        <v-btn
          color="error"
          variant="flat"
          :disabled="loading"
          :loading="loading"
          @click="handleDelete"
        >
          Delete
        </v-btn>
      </v-card-actions>
    </v-card>

    <!-- Snackbar -->
    
  </v-dialog>
  </div>
</template>

<script>
import { generateClient } from "aws-amplify/api";
const client = generateClient();
import { edit_user } from "@/graphql/mutations";
import SnackbarComponent from "@/components/Extras/Snackbar.vue";

export default {
  name: 'DeleteAdminDialog',
  components: {
    SnackbarComponent,
  },
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    adminEmail: {
      type: String,
      default: ''
    }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      loading: false,
      snackbar: {
        show: false,
        message: "",
        color: "success",
      },
    }
  },
  computed: {
    dialog: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit('update:modelValue', value)
      }
    }
  },
  watch: {
    modelValue(newVal) {
      if (!newVal) {
        this.resetForm()
      }
    }
  },
  methods: {
    handleClose() {
      this.dialog = false
      this.resetForm()
    },
    resetForm() {
      // No form to reset
    },
    async handleDelete() {
      this.loading = true

      try {
        const input = {
          user_email_id: this.adminEmail,
         
        };
        
       await client.graphql({
          query: edit_user,
          variables: {
            input: input,
          },
        });
        
        this.loading = false
        this.snackbar = {
          show: true,
          message: "Administrator deleted successfully",
          color: "success",
        };
        this.$emit("deleted", 0);
        this.handleClose();
      } catch (error) {
        console.error('Error deleting admin:', error);
        this.snackbar = {
          show: true,
          message: "Failed to delete administrator",
          color: "error",
        };
        this.loading = false;
      }
    }
  }
}
</script>

<style scoped>
</style>

